module.exports = __webpack_public_path__ + "img/logo-white.678c40b9.svg";